import styled from 'styled-components'

const SimpleSpacer = styled.div`
  height: ${(props: { $height: number }) => `${props.$height}px`};
`

export default SimpleSpacer
